import React from "react";
import { animated } from "react-spring";
import styled from "styled-components";
import { Media } from "../../../cms/models/common/Media";

interface Props {
  cover: Media;
}

const Cover = styled(animated.img)`
  width: 100%;
  max-height: 35vh;
  object-fit: cover;
`;

export const CmsPageCover: React.FC<Props> = (props) => {
  const getPageCoverUrl = () => {
    const { formats } = props.cover;

    // Prioritize formatted urls, preferably large
    if (formats && Object.values(formats).length > 0) {
      return (
        (formats.large && formats.large.url) ||
        (formats.medium && formats.medium.url) ||
        (formats.small && formats.small.url) ||
        (formats.thumbnail && formats.thumbnail.url)
      );
    }

    return props.cover.url;
  };

  return <Cover src={`${getPageCoverUrl()}`} />;
};
